export default {
    admin: () =>
        import(/* webpackChunkName: "admin" */ "js/api/modules/admin").then(
            m => m.default
        ),
    sortable: () =>
        import(/* webpackChunkName: "admin" */ "js/api/modules/sortable").then(
            m => m.default
        )
}
